import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const SidewaysLogo = (sideways = false) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq:  "sideways-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img fluid={data.placeholderImage.childImageSharp.fluid} />
}

export default SidewaysLogo
